module.exports = __webpack_public_path__ + "img/ba.ba83f6034.svg";